class Worker {
    constructor(_identity, _request) {
        this.request = _request;
        this.identity = _identity;
    }

    details() {
        return this.request.fetch({
            method: "GET",
            endpoint: `worker/${this.identity}`
        });
    }

    book(_data) {
        return this.request.fetch({
            method: "POST",
            endpoint: `worker/${this.identity}/book`,
            params: _data
        });
    }

}

export default Worker;